//#region > Imports
//> React
// Contains all the functionality necessary to define React components
import { StrictMode } from "react";
import {createRoot} from "react-dom/client";
//> Web vitals
import reportWebVitals from "./reportWebVitals";

//> Font Awesome
// Font Awesome is an awesome icon library
import "@fortawesome/fontawesome-free/css/all.min.css";

//> Bootstrap
import "bootstrap-css-only/css/bootstrap.min.css";

//> MDB
// "Material Design for Bootstrap" is a great UI design framework
import "mdbreact/dist/css/mdb.css";

//> CSS
// Root SCSS file
import "./index.scss";

//> Components
// Root component
import App from "./App";
//#endregion

//#region > Render
// Render the DOM

const container = document.getElementById('root');
const root =  createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
//#endregion

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/**
 * SPDX-License-Identifier: (EUPL-1.2)
 * Copyright © 2021 Christian Aichner
 */
